import { useTransactionReceipt } from 'wagmi';
import { formatEther, decodeEventLog, keccak256, toHex } from 'viem';
import BigNumber from 'bignumber.js';
import StakingABI from 'src/api/smart-contracts/abi/Staking';
import { CONTRACT_ADDRESSES } from 'src/constants';

const REDEEM_EVENT_SIGNATURE = keccak256(
  toHex('Redeem(address,address,uint256,uint256,uint256,uint256)')
);

export function useRedeemedAmount(hash?: `0x${string}`) {
  const { data, isLoading, error } = useTransactionReceipt({
    hash,
    query: {
      enabled: !!hash,
      select: (data) => {
        let totalAmount = new BigNumber(0);

        for (const log of data.logs) {
          if (
            log.address.toLowerCase() !==
            CONTRACT_ADDRESSES.staking.toLowerCase()
          ) {
            continue;
          }

          try {
            if (log.topics[0] === REDEEM_EVENT_SIGNATURE) {
              const decoded = decodeEventLog({
                abi: StakingABI,
                data: log.data,
                topics: log.topics,
              });

              if (decoded.eventName === 'Redeem') {
                totalAmount = totalAmount.plus(
                  formatEther(decoded.args.assets)
                );
              }
            }
          } catch (decodeError) {
            continue;
          }
        }

        return totalAmount.toString();
      },
    },
  });

  return {
    redeemedAmount: data,
    isLoadingRedeemedAmount: isLoading,
    redeemedAmountError: error,
  };
}
